var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$sonyProgram.isEVE())?_c('EveDashboard'):(_vm.$sonyProgram.isEUR())?_c('EueDashboard'):_c('CprDashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }